interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: 'center' | 'left';
  tone?: 'primary' | 'secondary' | 'accent';
}

const toneMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  secondary: 'bg-secondary-100 text-secondary-800',
  accent: 'bg-accent-100 text-accent-800',
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = 'center',
  tone = 'primary',
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  return (
    <div className={`${isCenter ? 'text-center mx-auto max-w-2xl' : 'text-left max-w-2xl'}`}>
      {eyebrow && (
        <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium ${toneMap[tone]}`}>
          <i className="ri-flashlight-line"></i>
          {eyebrow}
        </span>
      )}
      <h2 className="mt-4 text-2xl md:text-3xl text-foreground-950">{title}</h2>
      {desc && <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>}
    </div>
  );
}